export default "__VITE_ASSET__GwqPxqpw__"